/**
 * Copyright (c) 2023-present.
 * This source code is copied from https://github.com/justinmahar/react-social-media-embed
 */
import React, { useEffect, useState, useRef } from 'react'
import classNames from 'classnames'
import { SkeletonBox, Box } from 'chemistry'

const borderRadius = 8

export default function PinterestEmbed({ url, height = 500, width = 540, placeholderDisabled = false, ...divProps }) {
  const [ready, setReady] = useState(false)
  const frameRef = useRef(null)

  const postIdMatch = url.match(/pin\/([\w-]+)/)?.[1]
  const postId = postIdMatch ?? '000000000000000000'

  useEffect(() => {
    frameRef.current.src = `https://assets.pinterest.com/ext/embed.html?id=${postId}`
  }, [postId])

  return (
    <Box
      {...divProps}
      className={classNames('rsme-embed rsme-pinterest-embed', divProps.className)}
      sx={{
        overflow: 'hidden',
        width: '100%',
        maxWidth: `${width}px`,
        m: '0 auto',
        height: `${height}px`,
        borderRadius,
        ...divProps.style
      }}
    >
      <iframe
        ref={frameRef}
        className={classNames('pinterest-post', !ready && 'rsme-d-none')}
        width='100%'
        height={!ready ? 0 : `${height}px`}
        onLoad={() => setReady(true)}
        title='pinterest'
      />
      {!ready && !placeholderDisabled && <SkeletonBox url={url} height={height} />}
    </Box>
  )
}
